import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DynamicFilterTermPipe } from "./dynamic-filter-term.pipe";

@NgModule({
  imports: [CommonModule],
  declarations: [DynamicFilterTermPipe],
  exports: [DynamicFilterTermPipe]
})
export class DynamicFilterTermModule {}
